import { AssemblyTransitionState } from './AssemblyTransitionState';
import type { InteractionVisualStateRuntime } from './AbstractInteractionVisualState';
import type { Viewer } from '../../viewer/Viewer';

//------ 装配体模式下基准点线面 开始------
/**
 * 装配体模式下基准点视觉状态。
 *
 * 设计说明：
 * 1. 该类只表达装配体基准点命令的视觉语义；
 * 2. 当前阶段继承装配体视觉状态，保留 imported-model 树交互与包围盒高亮语义；
 * 3. 后续装配体基准点若需要专属颜色、过滤或辅助反馈，可在本类扩展。
 */
export class AssemblyReferencePointTransitionState extends AssemblyTransitionState {
    /**
     * 创建装配体模式下基准点视觉状态。
     *
     * @param runtime 视觉状态运行时。
     * @param viewer Viewer 实例。
     */
    public constructor(runtime: InteractionVisualStateRuntime, viewer: Viewer) {
        super(runtime, viewer);
    }
}
//------ 装配体模式下基准点线面 结束------
